import React from 'react'
import '../view/home.css'
import Hero from '../img/Hero Picture.png'
import pic1 from '../img/Picture.png'
import pic2 from '../img/Picture (1).png'
import pic3 from '../img/Picture (2).png'
import pic4 from '../img/Rectangle 72.png'
import pic5 from '../img/Rectangle 73.png'
import pic6 from '../img/Rectangle 75.png'
import pic7 from '../img/Pict 3.png'

function home() {
    return (
        <div>
            <img src={Hero} alt='herolu' className='hero' />
            <div className='teks'>
                <div className='summary'>
                    Travel With <br />
                Us, Cheaply
            </div>
                <div className='weather'>
                    28°C Cloudy
            </div>
                <div className='arrow'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16" className='mr-2'>
                        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-right-circle" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                    </svg>
                </div>
            </div>
            <div className='navigation d-flex flex-row'>
                <div className='col-md-3 nav'>
                    <p className='nav-title'>Location</p>
                    <div className='summary d-flex flex-row'>
                        <p className='nav-summary'>Your Destination</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16" className='icon'>
                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                        </svg>
                    </div>
                </div>
                <div className='col-md-3 nav'>
                    <p className='nav-title'>Activity</p>
                    <div className='summary d-flex flex-row'>
                        <p className='nav-summary'>Your Activity</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16" className='icon'>
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                        </svg>
                    </div>
                </div>
                <div className='col-md-2 nav'>
                    <p className='nav-title'>Date</p>
                    <div className='summary d-flex flex-row'>
                        <p className='nav-summary'>Set Date</p>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-calendar3" viewBox="0 0 16 16" className='icon'>
                            <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z" />
                            <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
                        </svg>
                    </div>
                </div>
                <div className='col-md-4 nav'>
                    <div className='search d-flex align-items-center'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16" className=''>
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                        </svg>
                    </div>
                </div>
                <div className='separator'></div>
                <div className='separator-2'></div>
            </div>
            <section className='hero-2'>
                <div className='hero-2-title'>
                    <h1>Recommended Building</h1>
                    <p>The most Brilliant reason NotCube has to be <br />
most Convenient and Cheap</p>
                </div>
                <div className='building'>
                    <div className='row row-cols-1 row-cols-md-3 g-4'>
                        <div className='col'>
                            <div class="card">
                                <div className='img'>
                                    <img src={pic1} className="card-img-top image-build" alt="..." />
                                    <p className='testi'>4.6</p>
                                </div>
                                <div class="card-body">
                                    <div className='top d-flex justify-content-between'>
                                        <h5 class="card-title">High Fly</h5>
                                        <p className='price'>$430</p>
                                    </div>
                                    <div className='bottom d-flex justify-content-between'>
                                        <div className='icon d-flex flex-row'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                            </svg>
                                            <p>Gambir, Jakarta</p>
                                        </div>
                                        <p className='price-2'>Per haur</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col'>
                            <div class="card active">
                                <div className='img'>
                                    <img src={pic2} className="card-img-top image-build" alt="..." />
                                    <p className='testi'>4.9</p>
                                </div>
                                <div class="card-body">
                                    <div className='top d-flex justify-content-between'>
                                        <h5 class="card-title">Stone Mountain</h5>
                                        <p className='price'>$700</p>
                                    </div>
                                    <div className='bottom d-flex justify-content-between'>
                                        <div className='icon d-flex flex-row'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                            </svg>
                                            <p>Padalarang, Bandung</p>
                                        </div>
                                        <p className='price-2'>Per haur</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col'>
                            <div class="card">
                                <div className='img'>
                                    <img src={pic3} className="card-img-top image-build" alt="..." />
                                    <p className='testi'>4.8</p>
                                </div>
                                <div class="card-body">
                                    <div className='top d-flex justify-content-between'>
                                        <h5 class="card-title">white Building</h5>
                                        <p className='price'>$380</p>
                                    </div>
                                    <div className='bottom d-flex justify-content-between'>
                                        <div className='icon d-flex flex-row'>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                            </svg>
                                            <p>Kebun Raya, Bogor</p>
                                        </div>
                                        <p className='price-2'>Per haur</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='hero-3'>
                <div className='hero-3-title'>
                    <h1>Gallery</h1>
                    <p>
                        This photo is from some of EzStay <br />
                        Favorite buildings
                    </p>
                </div>
                <div className='gallery'>
                    <div className='row'>
                        <div className='col-md-4'>
                            <img src={pic4} alt='' className='img' />
                        </div>
                        <div className='col-md-4'>
                            <img src={pic5} alt='' className='active-img img' />
                            <div className='info'>
                                <div className='title row'>
                                    <p className='info-title'>
                                        Glasses House
                                </p>
                                    <div className='testi-2 row'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                                            <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                                        </svg>
                                        <p>4.9</p>
                                    </div>
                                </div>
                                <div className='info-summary row'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                    </svg>
                                    <p>KBP, Bandung</p>
                                </div>
                                <div className='arrow'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='image'>
                                <img src={pic6} alt='' className='img-row' />
                                <img src={pic7} alt='' className='img-row mt-4' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}

export default home
